import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, merge } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingOverlayService {
    private loaderSubject = new BehaviorSubject<boolean>(false);
    loaderState$ = this.loaderSubject.asObservable();

    constructor() {
        window.addEventListener('offline', () => {
            this.hide();
        });
    }

    show() {
        this.loaderSubject.next(true);
    }

    hide() {
        this.loaderSubject.next(false);
    }
}
